import { render, staticRenderFns } from "./ExceptionDetils.vue?vue&type=template&id=5c96d358&scoped=true&"
import script from "./ExceptionDetils.vue?vue&type=script&lang=js&"
export * from "./ExceptionDetils.vue?vue&type=script&lang=js&"
import style0 from "./ExceptionDetils.vue?vue&type=style&index=0&id=5c96d358&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c96d358",
  null
  
)

export default component.exports